var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import styles from './Tag.scss';
import classNames from 'classnames';
import WixComponent from '../BaseComponents/WixComponent';
import Typography from '../Typography';
import SmallX from '../Icons/dist/components/SmallX';

var Tag = function (_WixComponent) {
  _inherits(Tag, _WixComponent);

  function Tag() {
    _classCallCheck(this, Tag);

    return _possibleConstructorReturn(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).apply(this, arguments));
  }

  _createClass(Tag, [{
    key: 'render',
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          id = _props.id,
          children = _props.children,
          thumb = _props.thumb,
          removable = _props.removable,
          onRemove = _props.onRemove,
          size = _props.size,
          wrap = _props.wrap,
          disabled = _props.disabled,
          theme = _props.theme;


      var className = classNames((_classNames = {}, _defineProperty(_classNames, styles.tag, true), _defineProperty(_classNames, styles.large, size === 'large'), _defineProperty(_classNames, styles.tagWrap, wrap), _defineProperty(_classNames, styles.disabled, disabled), _defineProperty(_classNames, styles[theme + 'Theme'], true), _classNames));

      var innerClassName = classNames((_classNames2 = {}, _defineProperty(_classNames2, styles.innerTagWrap, wrap), _defineProperty(_classNames2, Typography.t4, true), _classNames2));

      var title = wrap ? children : '';

      return React.createElement(
        'span',
        { className: className, disabled: disabled, id: id, title: title },
        thumb && React.createElement(
          'span',
          { className: styles.thumb },
          thumb
        ),
        React.createElement(
          'span',
          { className: innerClassName },
          children
        ),
        removable && !disabled && React.createElement(
          'a',
          { className: styles.tagRemoveButton, onClick: function onClick() {
              return onRemove(id);
            } },
          React.createElement(SmallX, null)
        )
      );
    }
  }]);

  return Tag;
}(WixComponent);

Tag.propTypes = {
  children: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  thumb: PropTypes.element,
  onRemove: PropTypes.func,
  removable: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'large']),
  wrap: PropTypes.bool,
  disabled: PropTypes.bool,
  theme: PropTypes.oneOf(['standard', 'error', 'warning'])
};

Tag.defaultProps = {
  onRemove: function onRemove() {},
  size: 'small',
  removable: true,
  theme: 'standard'
};

export default Tag;
//# sourceMappingURL=Tag.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Tag/Tag.js